angular.module('unica_event.event_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// EVENT
		.state('app.event', {
			url: '/event',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/event/templates/event.html',
					controller: 'EventBasicController'
				}
			},
			params: {
				need_auth: true,
				//parent: 'app.event_years'
			}
		})

			// EVENT YEARS
			.state('app.event.years', {
				url: '/years',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/years.html',
						controller: 'EventYearsController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Eventi'
				}
			})

			// EVENT LIST AND DELETE
			.state('app.event.list', {
				url: '/:year/list',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/list.html',
						controller: 'EventListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Eventi {{ year }}',
					parent: 'app.event.years'
				}
			})

			// EVENT DETAIL
			.state('app.event.detail', {
				url: '/:year/detail/:id',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/detail.html',
						controller: 'EventDetailController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: '{{ eventData.title }}',
					parent: function($rootScope) {
						return 'app.event.list({ year:' + $rootScope.year + '})';
					}
				}
			})

			// EVENT CREATE
			.state('app.event.create', {
				url: '/:year/create',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/create.html',
						controller: 'EventCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Evento',
					parent: function($rootScope) {
						return 'app.event.list({ year:' + $rootScope.year + '})';
					}
				}
			})


			// EVENT EDIT
			.state('app.event.edit', {
				url: '/:year/edit/:id',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/edit.html',
						controller: 'EventEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Evento',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// EVENT SITE
			.state('app.event.site', {
				url: '/:year/site/:event_id',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/site.html',
						controller: 'EventSiteController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Sito',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})


			// EVENT SITE
			.state('app.event.texts', {
				url: '/:year/texts/:event_id',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/event_texts.html',
						controller: 'EventTextsController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Personalizza Testi',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

			// EVENT SEND
			.state('app.event.send', {
				url: '/:year/send/:event_id',
				views: {
					'eventContent': {
						templateUrl: './modules/event/templates/send.html',
						controller: 'EventSendController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Gestisci Invio',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + '})';
					}
				}
			})

	;

});

